/*
 * @Author: zchanghua
 * @Date: 2023-08-13 23:34:11
 * @LastEditors: zchanghua
 * @LastEditTime: 2026-01-22 17:23:42
 * @FilePath: /xrweb/src/store/modules/login.ts
 * @Description: 
 */
import { Module } from "vuex";
import { StoreState } from "../types";
import { login, logout, UserInfo, getUserModules } from "@/services/login";
import { setUserInfo, clearUserInfo, getUserInfo } from "@/utils/authority";

// 默认模块列表
const DEFAULT_MODULES = [
  'uploadModel',
  'uploadImg',
  'uploadDoc',
  'uploadVideo',
  'uploadAudio',
  'uploadAb',
  'uploadPoints',
  'uploadidentify',
  'XRMap',
  'XREditor',
  'XRView'
];

export interface LoginModuleState {
  userInfo: UserInfo;
}

const user: Module<LoginModuleState, StoreState> = {
  namespaced: true,
  state: {
    userInfo: getUserInfo(),
  },
  getters: {},
  mutations: {
    setUserInfo(state, userInfo: UserInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {
    async login({ commit }, data: Record<string, any>) {
      // 1. 调用登录接口
      const res = await login(data);
      console.log("getUserList", res);
      if (res.respCode === 200) {
        // 2. 初始化用户信息（包含默认模块）
        const userInfoWithModules: UserInfo = {
          ...res.data,
          modules: DEFAULT_MODULES // 先赋默认值
        };
        // 3. 获取用户ID并请求模块接口
        const userId = res.data.userId;
        if (userId) {
          try {
            const modulesRes = await getUserModules(userId);
            if (modulesRes.respCode === 200 && modulesRes.data.modules) {
              // 更新为获取到的模块
              userInfoWithModules.modules = modulesRes.data.modules;
            }
          } catch (error) {
            console.warn("获取模块失败，使用默认模块:", error);
            // 获取失败，保持默认模块
          }
        }
        setUserInfo(userInfoWithModules);
        commit("setUserInfo", userInfoWithModules);
      }
      return res;
    },
    async logout({ commit }, data: Record<string, any>) {
      const res = await logout();
      console.log("注销操作");
      // if (res.respCode === 200) {
      // }
      clearUserInfo();
      commit("setUserInfo", {});
      return res;
    },
  },
};

export default user;
